import { isNil } from 'lodash';
import * as orderPaymentService from 'services/orderPaymentService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWROrderPaymentsData = Awaited<
  ReturnType<typeof orderPaymentService.getOrderPaymentsAsync>
>;

const useOrderPayments = (
  orderId: number,
  load = true
): SWRResponse<SWROrderPaymentsData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_ORDER_PAYMENTS_ENDPOINT, orderId] : null,
    async ([_, params]) => await orderPaymentService.getOrderPaymentsAsync(params)
  );

export const SWR_ORDER_PAYMENTS_ENDPOINT = 'order-payments';
export default useOrderPayments;
